import PageBreakV1 from "../../../../components/form_builder/elements/page_break/PageBreakV1.vue";

export default {
  componentName: "fb-page-break-v1",
  component: PageBreakV1,
  defaultAttrs: {
    properties: {
      value: "Page break",
      style: {},
      hideOnEdit: false,
      hideOnView: false,
      hidden: false,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
